const shortenDomain = (domain) =>
  domain.length < 25 || domain.split(".").length <= 2
    ? domain
    : shortenDomain(domain.split(".").slice(1).join("."));

export default {
  install(Vue) {
    /**
     * Removes first subdomain of long domains
     *
     * @returns string
     * @param domain string
     */
    Vue.prototype.$formatShortDomain = (domain) => shortenDomain(domain);
  },
};
